import React from 'react'
import '../../styles/ConciergeModule/GreetingImage.scss'

interface GreetingImageProps {
    url: string,
    altText: string,
}

export const GreetingImage = ({ url, altText } : GreetingImageProps) => {
  return <div className="greeting-image">
        <img src={url} alt={altText} />
    </div>
}
